export default {"src":"/_next/static/media/boxMeasure.6c093fc8.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};